<template lang="pug">
.keyboardInput(
  @keydown="handleKeyDown($event)"
  tabindex="0"
  ref="self"
)
  .debug(v-if="false")
    | preText: {{ preText }}<br>
    | backspaceCount: {{ backspaceCount }}<br>
    | wrongCount: {{ wrongCount }}<br>
    | wrongLogs: {{ wrongLogs }}

  .debug2(v-if="false")
    | inputText: {{ inputText }}

  transition(name="pop" duration="500" mode="out-in")
    .targetText(
      :key="targetText | join"
      v-if="targetText"
      ref="targetTextDOM"
    )
      .clause(
        v-for="targetClause in targetClauses"
        :class="{current: targetClause.isCurrent}"
        :ref="targetClause.isCurrent ? 'currentClauseDOM' : 'clauseDOM'"
      )
        //- .preview
        //-   | {{targetClause.previewText}}
        .hiragana
          .character(
            v-for="targetCharacter in targetClause.text"
            :class=`{
              matched: targetCharacter.value === inputCharacters[targetCharacter.index],
              wrong: inputCharacters[targetCharacter.index] && inputCharacters[targetCharacter.index] !== '＊' && targetCharacter.value !== inputCharacters[targetCharacter.index],
              current: targetCharacter.index === cleansedInputText.length
            }`
            :ref="targetCharacter.index === inputText.length ? 'currentTargetTextCharacterDOM' : 'targetTextCharacterDOM'"
          ) {{inputCharacters[targetCharacter.index] ? inputCharacters[targetCharacter.index] : '○' }}

  //- .clearMessage(:class="{ hidden: !isFinished }") お見事！
</template>

<script>
import * as _ from 'lodash'
import soundService from '@/services/SoundService'
import inputService from '@/services/InputService'

export default {
  name: 'km-keyboard-input',
  components: {},
  props: {
    lock: {
      type: Boolean,
      default: false
    },
    targetText: {
      default: () => []
    },
    targetPreviewText: {
      default: () => []
    }
  },
  filters: {
    join: function(value) {
      return value.join()
    }
  },
  data() {
    return {
      isReady: false,
      isFinished: false,
      preText: '',
      inputText: '',
      leftHand: { x: 0, y: 2 },
      rightHand: { x: 0, y: 2 },
      currentKey: {},
      currentKeyResetTimer: null,
      keys: [],
      backspaceCount: 0,
      isWronged: false,
      wrongCount: 0,
      wrongLogs: []
    }
  },
  computed: {
    targetClauses: function() {
      if (!this.targetText) return []
      // カウンターを使って全体でindexが割り振られるようにする
      let count = 0

      const clauses = this.targetText.map((text, i) => {
        const minCount = count
        const textCharacters = text.split('')
        const textObject = textCharacters.map(character => {
          count += 1
          return {
            index: count - 1,
            value: character
          }
        })

        const cleansedInputText = this.inputText.replace(/＊+$/g, '') // checkAnswerでは全体、ここでは後方にある返還前の米印のみ削除

        const clause = {
          isCurrent:
            (this.inputText.length >= minCount ||
              (minCount === 0 && this.inputText.length === 0)) &&
            cleansedInputText.length < count,
          minIndex: minCount,
          maxIndex: count,
          text: textObject,
          previewText: this.targetPreviewText[i]
        }
        return clause
      })
      return clauses
    },
    /**
     * 入力文字列から階層を持たない配列を作成(照合に使用)
     */
    inputCharacters: function() {
      return this.inputText.split('')
    },
    cleansedInputText: function() {
      return this.inputText.replace(/＊+$/g, '')
    },
    correctCharacterCount() {
      if (!this.targetText) return
      const targetCharacterArray = this.targetText.join('').split('')
      const inputCharacterArray = this.inputText.replace(/＊/g, '').split('')
      let count = 0
      targetCharacterArray.forEach((targetCharacter, index) => {
        if (targetCharacter === inputCharacterArray[index]) count++
      })
      return count
    }
  },
  watch: {
    targetText: function() {
      this.reset()
    },
    inputText: _.debounce(function() {
      this.scrollToCurrentCharacter()
    }, 90)
  },
  methods: {
    reset() {
      this.inputText = ''
      this.preText = ''
      this.isFinished = false
      this.isReady = true
    },
    focus() {
      this.$refs.self.focus()
    },
    /**
     * 入力文字列の追加
     */
    updateText(event) {
      this.inputText += '＊'
      this.preText += event.key.toLowerCase()
    },
    /**
     * 仮入力分の変換を試みる
     */
    addText() {
      // convertPreText
      const matchedPattern = inputService.getPatternByRomaji(this.preText)
      if (_.isEmpty(matchedPattern)) {
        return false
      }
      this.inputText =
        this.inputText.slice(0, -matchedPattern.input.length) +
        matchedPattern.output
      this.preText = ''
      return true
    },
    playHitSound(isCorrected, isConverted, keyY) {
      if (isCorrected) {
        if (isConverted) {
          soundService.play('vowel')
          return
        }
        switch (keyY) {
          case 1:
            soundService.play('keyUpper')
            break
          case 2:
            soundService.play('key')
            break
          case 3:
            soundService.play('keyLower')
            break
        }
      } else {
        soundService.play('fail')
      }
    },
    countWrongCharacter(textA, textB) {
      let count = 0
      const charactersA = textA.split('')
      const charactersB = textB.split('')
      charactersA.forEach((character, i) => {
        if (character !== charactersB[i]) count++
      })
      return count
    },
    /**
     * 合否判定
     */
    checkAnswer() {
      const joinedTargetText = this.targetText.join('')
      this.wrongCount = this.countWrongCharacter(
        joinedTargetText,
        this.inputText
      )
      const cleansedInputText = this.inputText.replace(/＊/g, '')
      const isCorrected = joinedTargetText.indexOf(cleansedInputText) === 0

      const isNewWrongCharacter = !isCorrected && this.isWronged === false
      if (isNewWrongCharacter) {
        this.isWronged = true
        this.wrongLogs.push({
          targetCharacter: joinedTargetText.slice(
            cleansedInputText.length - 1,
            cleansedInputText.length
          ),
          inputCharacter: cleansedInputText.slice(-1)
        })
      } else if (isCorrected) {
        this.isWronged = false
      }
      this.isFinished = joinedTargetText === this.inputText
      return isCorrected
    },
    scrollToCurrentCharacter() {
      if (_.isEmpty(this.$refs.currentClauseDOM)) return
      let offsetTop = this.$refs.currentClauseDOM[0].offsetTop
      const halfScreenSize = 309
      this.$refs.self.scrollTop = offsetTop - halfScreenSize
    },
    removeInput() {
      soundService.play('vanish')
      this.inputText = this.inputText.slice(0, -1)
      this.preText = this.preText.slice(0, -1)
    },
    /**
     * キーを押した時の処理
     */
    handleKeyDown(event) {
      if (this.lock) return
      if (
        (!this.isReady && event.code !== 'Space') ||
        (this.isFinished && event.code !== 'Space')
      ) {
        return
      }
      const key = inputService.getKeyDetail(event.code)
      const isAcceptedKey = !_.isEmpty(key)
      if (isAcceptedKey) {
        // 入力対象キー
        this.updateText(event)
        const isConverted = this.addText()
        const isCorrected = this.checkAnswer(key, event)
        if (isCorrected) {
          this.$emit('onCorrectInput', isConverted)
        } else {
          this.removeInput()
          this.$emit('onMissInput')
        }
        this.playHitSound(isCorrected, isConverted, key.y)
        if (this.isFinished) {
          this.$emit('onInputFinished', {
            inputText: this.inputText,
            backspaceCount: this.backspaceCount,
            wrongLogs: this.wrongLogs
          })
        }
      } else if ( event.code === 'Backspace' ) {
        this.backspaceCount += 1
        this.removeInput()
      } else if ( event.code === 'Space' ) {
        this.$emit('onSpaceKeyDown')
      }
      this.$emit('onInput', this.correctCharacterCount)
    }
  },
  mounted() {
    this.$refs.self.focus()
    this.$refs.self.addEventListener('blur', this.focus)
  },
  beforeDestroy() {
    this.$refs.self.removeEventListener('blur', this.focus)
  }
}
</script>

<style lang="scss" scoped>
.debug {
  position: fixed;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  text-align: left;
  font-size: 12px;
  z-index: 10000;
}

.debug2 {
  position: fixed;
  right: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 12px;
  z-index: 10000;
}

.keyboardInput {
  &:focus {
    outline: none;
  }
}

.targetText {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0 30px;
  height: 70px;
  background: #fff;
  border-radius: 10px;

  &::after {
    position: absolute;
    left: calc(50% - 10px);
    bottom: -10px;
    content: '';
    display: block;
    width: 20px;
    height: 10px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 55.16 27.58'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Cg%3E%3Cg%3E%3Cpolyline class='cls-1' points='55.16 0 27.58 27.58 0 0'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }
}

.clause {
  position: relative;
  display: inline-block;
  margin: 0 15px 0 0;
  // height: 150px;
  background-size: 100% 100%;
  text-align: center;
  opacity: 1;
  transform: scale(0.9);
  box-sizing: border-box;

  &:last-child {
    margin: 0;
  }

  &.current {
    transform: scale(1);
    opacity: 1;
  }

  // &::before {
  //   content: '';
  //   position: absolute;
  //   top: -10px;
  //   left: 0;
  //   display: block;
  //   width: 30px;
  //   height: 170px;
  //   // background: url(../../assets/scroll_left.png) no-repeat;
  //   background-size: 100% 100%;
  // }

  // &::after {
  //   content: '';
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  //   display: block;
  //   width: 30px;
  //   height: 150px;
  //   // background: url(../../assets/scroll_right.png) no-repeat;
  //   background-size: 100% 100%;
  // }

  .preview {
    font-size: 5rem;
    font-weight: bold;
    font-family: serif;
  }

  .hiragana {
    font-size: 2.5rem;
    opacity: 0.9;
  }
}

// 文字
.character {
  display: inline-block;
  height: 45px;
  border-radius: 5px;
  color: #333;
  transition-property: margin, padding, background, color, border-radius;

  &.current {
    background: orange;
    color: #fff;
  }

  &.matched {
    color: orange;
  }

  &.wrong {
    margin: 0 -3px;
    padding: 0 6px;
    background: red;
    color: #fff;
  }
}

.clearMessage,
.goodMessage {
  position: fixed;
  top: calc(50% - 100px);
  left: calc(50% - 300px);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 600px;
  height: 150px;
  border: 10px solid red;
  color: red;
  background: #fff;
  font-size: 60px;
  font-weight: bold;
  font-family: serif;
  opacity: 1;
  transform: scale(1.5) rotate(-15deg);
  transition-property: transform, opacity;

  &.hidden {
    transform: scale(0.5);
    opacity: 0;
  }
}

@keyframes blink {
  from,
  to {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
</style>
